import { render, staticRenderFns } from "./LibBaseIcon.vue?vue&type=template&id=4462bf96&scoped=true&"
import script from "./LibBaseIcon.vue?vue&type=script&lang=ts&"
export * from "./LibBaseIcon.vue?vue&type=script&lang=ts&"
import style0 from "./LibBaseIcon.vue?vue&type=style&index=0&id=4462bf96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4462bf96",
  null
  
)

export default component.exports